import { createContext } from "react";

export const PlansContext = createContext();
